<template>
  <HeaderBase>
    <div class="flex items-center shrink header-title w-1/5">
      <span class="arrow arrow-r arrow-primary"></span>
      <b>Заказчики</b>
      <span class="header-counter font-rubik cursor-default">{{ total }}</span>
    </div>
    <div class="shrink flex-container flex-dir-row align-center">
      <IwalyInput
        classes="border-muted-light"
        placeholder="Поиск: ID, ФИО, телефон, email, город"
        input-mode="search"
        enter-key-hint="search"
        @enter="find"
        @blur="blur"
        v-model="value">
        <template slot="input:prepend">
          <div class="icon h-full">
            <img class="h-full" src="@/assets/icons/loupe.svg" alt="">
          </div>
        </template>
      </IwalyInput>
    </div>
  </HeaderBase>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import Input from '@/components/Input.vue';
import HeaderBase from './HeaderBase.vue';

export default {
  components: {
    HeaderBase,
    IwalyInput: Input,
  },
  data() {
    return {
      value: String(this.$route.query.search || ''),
    };
  },
  computed: {
    ...mapState({
      payload: (state) => state.customers.data,
    }),
    total() {
      return _.get(this.payload, 'total') || null;
    },
  },
  methods: {
    find(value, event) {
      const normalized = String(value ?? this.value ?? '').trim();
      this.value = normalized;
      this.$eventBus.$emit('find.customer', normalized);
      if (event && event.target && typeof event.target.blur === 'function') {
        event.target.blur();
      }
    },
    blur() {
      if (String(this.value || '').trim() === '') {
        this.value = '';
        this.$eventBus.$emit('find.customer', '');
      }
    },
  },
  watch: {
    '$route.query.search': function routeSearchChanged(value) {
      const next = String(value || '');
      if (next !== this.value) {
        this.value = next;
      }
    },
  },
  mounted() {
    this.$eventBus.$on('find.customer.value', (data) => {
      this.value = String(data || '');
    });
  },
  beforeDestroy() {
    this.$eventBus.$off('find.customer.value');
  },
};
</script>
